module.exports = __webpack_public_path__ + "media/images/bg_mv_purchasing_apartment_sp-69c94c5e632db929b1ed838180bde540.jpg";